import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";

const BuyInvoice = () => {
    const params = useParams();
    const authHeader = useAuthHeader();
    const [invoice, setInvoice] = useState(null);

    useEffect(() => {
        if (params?.id) {
            const fetchInvoice = async () => {
                const resp = await fetch(
                    `${REACT_APP_BACKEND_URL}/invoices/buyInvoice/${params.id}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: authHeader,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const result = await resp.json();
                console.log(result);
                setInvoice(result);
            };
            fetchInvoice();
        }
    }, [authHeader, params.id]);

    // Parse items from JSON string
    const items = JSON.parse(invoice?.items || "{}");
    if (params?.id && invoice) {
        return (
            <Box
                sx={{
                    p: 3,
                    maxWidth: 800,
                    mx: "auto",
                    bgcolor: "background.paper",
                    boxShadow: 3,
                    borderRadius: 2,
                }}
            >
                {/* Header */}
                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    textAlign="center"
                >
                    Invoice Details
                </Typography>

                {/* Invoice Information */}
                <Box mb={4}>
                    <Typography variant="h6" gutterBottom>
                        Invoice Info
                    </Typography>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Typography>ID: {invoice.id}</Typography>
                        <Typography>
                            Date: {new Date(invoice.createdAt).toLocaleString()}
                        </Typography>
                    </Box>
                    <Typography>Total Price: ${invoice.totalPrice}</Typography>
                </Box>

                {/* Employee Information */}
                <Box mb={4}>
                    <Typography variant="h6" gutterBottom>
                        Employee Info
                    </Typography>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Typography>Name: {invoice.employee.name}</Typography>
                        <Typography>
                            Username: {invoice.employee.username}
                        </Typography>
                    </Box>
                </Box>

                {/* Customer Information */}
                <Box mb={4}>
                    <Typography variant="h6" gutterBottom>
                        Customer Info
                    </Typography>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Typography>Name: {invoice.otherParty.name}</Typography>
                        <Typography>
                            Phone: {invoice.otherParty.phone}
                        </Typography>
                    </Box>
                </Box>

                {/* Items */}
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Items
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Quantity</TableCell>
                                    <TableCell>Remaining Stock</TableCell>
                                    <TableCell>Expiry Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{item.id}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>${item.price}</TableCell>
                                        <TableCell>{item.quantity}</TableCell>
                                        <TableCell>
                                            {item.quantityRemaining}
                                        </TableCell>
                                        <TableCell>
                                            {new Date(
                                                item.expiryDate
                                            ).toLocaleDateString()}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        );
    }
    return <div>no invoice with ID</div>;
};

export default BuyInvoice;
